import React, { useState } from 'react';
import { FiDownload, FiRefreshCw } from 'react-icons/fi';

import { useVersionCheck } from '../../hooks/useVersionCheck';
import { clearAppCache, hardReload } from '../../utils/clearCache';

import { Banner, UpdateButton } from './styles';

const UpdateBanner: React.FC = () => {
  const { hasUpdate } = useVersionCheck();
  const [updating, setUpdating] = useState(false);

  if (!hasUpdate) return null;

  const handleUpdate = async () => {
    setUpdating(true);
    await clearAppCache();
    hardReload();
  };

  return (
    <Banner role="alert">
      <span className="label">
        <FiDownload size={14} />
        Uma nova versão do painel está disponível.
      </span>
      <UpdateButton type="button" onClick={handleUpdate} disabled={updating}>
        <FiRefreshCw size={13} />
        {updating ? 'Atualizando...' : 'Atualizar agora'}
      </UpdateButton>
    </Banner>
  );
};

export default UpdateBanner;
